/**
 * Cart service-agreement offer (Zendesk #35801).
 * Per-line chip opens modal; "Læg i kurv" adds via /cart/add.js without closing modal;
 * refreshes drawer/cart in background. Layout: thumb → price → title → period → ATC.
 * Guarded against double init. Event delegation for drawer re-renders.
 */
(function () {
  if (window.__shopheltenServiceAgreementsCartInit) return;
  window.__shopheltenServiceAgreementsCartInit = true;

  var openModalEl = null;
  var modalHome = null;
  var adding = false;

  function moneyFormat(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (Number(cents) / 100).toLocaleString('da-DK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  function shopRoot() {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cartAddUrl() {
    return shopRoot() + 'cart/add.js';
  }

  /* ——— Per-line cart modal ——— */

  function closestCartRoot(el) {
    if (!el) return null;
    var root = el.closest('[data-sh-sa-cart]');
    if (root) return root;
    var modal = el.closest('[data-sh-sa-cart-modal]');
    if (modal && modalHome && modalHome.root) return modalHome.root;
    if (modal && modal.dataset.shSaUid) {
      return document.querySelector(
        '[data-sh-sa-cart][data-sh-sa-uid="' + modal.dataset.shSaUid + '"]'
      );
    }
    return null;
  }

  function getModal(root) {
    return root ? root.querySelector('[data-sh-sa-cart-modal]') : null;
  }

  function modalScope(root) {
    return openModalEl || (root && getModal(root)) || root;
  }

  function updatePriceDisplay(select) {
    var item = select.closest('[data-sh-sa-agreement]');
    if (!item) return;
    var option = select.options[select.selectedIndex];
    var priceEl = item.querySelector('[data-sh-sa-price]');
    if (priceEl && option && option.dataset.price) {
      priceEl.textContent = moneyFormat(option.dataset.price);
    }
  }

  function openModal(root) {
    var modal = getModal(root);
    if (!modal) return;
    closeModal();
    modalHome = { parent: modal.parentNode, next: modal.nextSibling, root: root };
    document.body.appendChild(modal);
    modal.hidden = false;
    openModalEl = modal;
    document.documentElement.classList.add('sh-sa-cart-modal-open');
    var firstFocus =
      modal.querySelector('.sh-sa-cart__add:not([disabled])') ||
      modal.querySelector('[data-sh-sa-cart-close]');
    if (firstFocus && typeof firstFocus.focus === 'function') {
      try {
        firstFocus.focus();
      } catch (e) {}
    }
  }

  function restoreModalHome(modal) {
    if (!modalHome || !modalHome.parent) {
      modalHome = null;
      return;
    }
    if (modalHome.next && modalHome.next.parentNode === modalHome.parent) {
      modalHome.parent.insertBefore(modal, modalHome.next);
    } else {
      modalHome.parent.appendChild(modal);
    }
    modalHome = null;
  }

  function closeModal() {
    if (!openModalEl) {
      document.querySelectorAll('[data-sh-sa-cart-modal]:not([hidden])').forEach(function (m) {
        m.hidden = true;
        if (m.parentNode === document.body) {
          m.remove();
        }
      });
      document.documentElement.classList.remove('sh-sa-cart-modal-open');
      modalHome = null;
      return;
    }
    openModalEl.hidden = true;
    var err = openModalEl.querySelector('[data-sh-sa-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }
    if (modalHome && modalHome.parent && document.body.contains(modalHome.parent)) {
      restoreModalHome(openModalEl);
    } else if (openModalEl.parentNode === document.body) {
      openModalEl.remove();
      modalHome = null;
    }
    openModalEl = null;
    document.documentElement.classList.remove('sh-sa-cart-modal-open');
  }

  function showError(root, message) {
    var scope = openModalEl || (root && getModal(root)) || root;
    if (!scope) return;
    var err = scope.querySelector('[data-sh-sa-error]');
    if (!err) return;
    err.textContent = message || 'Kunne ikke tilføje til kurv';
    err.hidden = false;
  }

  function refreshCartUI(data) {
    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      try {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data || {});
      } catch (e) {}
    }

    var cartDrawer = document.querySelector('m-cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.onCartDrawerUpdate === 'function') {
        cartDrawer.onCartDrawerUpdate();
      } else if (data && data.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.dispatchEvent(new Event('updateCartDrawer'));
      }
      if (
        data &&
        typeof data.item_count === 'number' &&
        typeof cartDrawer.updateCartCount === 'function'
      ) {
        cartDrawer.updateCartCount(data.item_count);
      }
    }

    var mainCart = document.querySelector('m-cart');
    if (mainCart && typeof mainCart.onCartUpdate === 'function') {
      mainCart.onCartUpdate();
    }

    if (
      (!data || typeof data.item_count !== 'number') &&
      cartDrawer &&
      typeof cartDrawer.getCart === 'function'
    ) {
      cartDrawer
        .getCart()
        .then(function (cart) {
          if (cart && typeof cartDrawer.updateCartCount === 'function') {
            cartDrawer.updateCartCount(cart.item_count);
            cartDrawer.classList.toggle('m-cart--empty', cart.item_count === 0);
          }
        })
        .catch(function () {});
    }
  }

  function getSectionsForAdd() {
    var sections = [];
    var cartDrawer = document.querySelector('m-cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      sections = sections.filter(function (id, i, arr) {
        return arr.indexOf(id) === i;
      });
    }
    return sections;
  }

  function variantIdFromAddButton(btn, scope) {
    if (!btn) return null;
    var item = btn.closest('[data-sh-sa-agreement]');
    var select = item ? item.querySelector('.sh-sa-cart__period-select') : null;
    if (!select && scope) {
      var index = btn.dataset.agreementIndex;
      select = scope.querySelector(
        '.sh-sa-cart__period-select[data-agreement-index="' + index + '"]'
      );
    }
    if (select && select.value) return parseInt(select.value, 10);
    return null;
  }

  function setBusy(scope, busy) {
    adding = !!busy;
    if (!scope) return;
    scope.querySelectorAll('.sh-sa-cart__add, .sh-sa-cart__period-select').forEach(function (el) {
      if (el.closest('.sh-sa-cart__item--added')) {
        el.disabled = true;
        return;
      }
      el.disabled = !!busy;
    });
  }

  function clearError(scope) {
    if (!scope) return;
    var err = scope.querySelector('[data-sh-sa-error]');
    if (!err) return;
    err.hidden = true;
    err.textContent = '';
  }

  function markRowAdded(btn) {
    if (!btn) return;
    var item = btn.closest('[data-sh-sa-agreement]');
    if (!item) return;
    item.classList.add('sh-sa-cart__item--added');
    btn.disabled = true;
    btn.textContent = 'Tilføjet';
    btn.setAttribute('aria-disabled', 'true');
    var select = item.querySelector('.sh-sa-cart__period-select');
    if (select) select.disabled = true;
    var note = item.querySelector('[data-sh-sa-added]');
    if (!note) {
      note = document.createElement('span');
      note.className = 'sh-sa-cart__added';
      note.setAttribute('data-sh-sa-added', '');
      note.textContent = 'Tilføjet';
      var content = item.querySelector('.sh-sa-cart__content');
      if (content) content.appendChild(note);
      else item.appendChild(note);
    }
    note.hidden = false;
  }

  function addToCart(root, btn) {
    var scope = modalScope(root);
    if (!scope || adding) return;

    if (btn && btn.closest('.sh-sa-cart__item--added')) return;

    var variantId = variantIdFromAddButton(btn, scope);
    if (!variantId) {
      showError(root, 'Vælg en serviceaftale');
      return;
    }

    setBusy(scope, true);
    clearError(scope);

    var body = {
      items: [{ id: variantId, quantity: 1 }],
    };
    var sections = getSectionsForAdd();
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status) {
          showError(root, data.description || data.message || 'Kunne ikke tilføje til kurv');
          return;
        }
        // Keep modal open — only user closes it. Refresh drawer in background.
        markRowAdded(btn);
        refreshCartUI(data);
      })
      .catch(function () {
        showError(root, 'Kunne ikke tilføje til kurv');
      })
      .finally(function () {
        setBusy(scope, false);
        if (scope) {
          scope
            .querySelectorAll(
              '.sh-sa-cart__item--added .sh-sa-cart__add, .sh-sa-cart__item--added .sh-sa-cart__period-select'
            )
            .forEach(function (el) {
              el.disabled = true;
            });
        }
      });
  }

  /* ——— Events ——— */

  document.addEventListener(
    'click',
    function (e) {
      var openBtn = e.target.closest('[data-sh-sa-cart-open]');
      if (openBtn) {
        e.preventDefault();
        openModal(closestCartRoot(openBtn));
        return;
      }

      var closeBtn = e.target.closest('[data-sh-sa-cart-close]');
      if (closeBtn) {
        e.preventDefault();
        closeModal();
        return;
      }

      var addBtn = e.target.closest('[data-sh-sa-add]');
      if (addBtn) {
        e.preventDefault();
        if (addBtn.disabled || addBtn.closest('.sh-sa-cart__item--added')) return;
        var root = closestCartRoot(addBtn);
        addToCart(root, addBtn);
      }
    },
    true
  );

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-sh-sa-period]');
    if (select) {
      updatePriceDisplay(select);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openModalEl) closeModal();
  });
})();
